import type Phaser from 'phaser';
import cake from '../../../../tile_assets/02_Interiors/32x32/Theme_Sorter_Singles_32x32/10_Birthday_Party_Singles_32x32/Birthday_Party_Singles_32x32_9.png';
import balloonYellow from '../../../../tile_assets/02_Interiors/32x32/Theme_Sorter_Singles_32x32/10_Birthday_Party_Singles_32x32/Birthday_Party_Singles_32x32_33.png';
import balloonBlue from '../../../../tile_assets/02_Interiors/32x32/Theme_Sorter_Singles_32x32/10_Birthday_Party_Singles_32x32/Birthday_Party_Singles_32x32_34.png';
import balloonRed from '../../../../tile_assets/02_Interiors/32x32/Theme_Sorter_Singles_32x32/10_Birthday_Party_Singles_32x32/Birthday_Party_Singles_32x32_35.png';
import partyCone from '../../../../tile_assets/04_Characters/Character_Generator/Accessories/16x16/Accessory_19_Party_Cone_01.png';
import { FRAMES_PER_DIRECTION, SHEET_FRAME, type CharacterAnimation } from './characters.js';

/**
 * Birthday art from LimeZu's Modern Interiors (assets-src/LICENSES.md): the "Birthday Party"
 * singles (cake, balloons) and the character generator's "Party Cone" accessory, a hat layer drawn
 * frame for frame over the same 16×32 character frames as the premade characters.
 */

export const CAKE_KEY = 'birthday:cake';
export const BALLOON_KEYS = [
  'birthday:balloon:yellow',
  'birthday:balloon:red',
  'birthday:balloon:blue',
] as const;
const PARTY_HAT_KEY = 'birthday:party-hat';

/** Rows of the character generator sheet layout: row 1 is the idle loop, row 2 walking. */
const HAT_ROWS: Readonly<Record<CharacterAnimation, number>> = { idle: 1, walk: 2 };
const HAT_FRAMES_PER_ROW = FRAMES_PER_DIRECTION * 4;

export function loadBirthdayArt(scene: Phaser.Scene): void {
  scene.load.image(CAKE_KEY, cake);
  const [yellow, red, blue] = BALLOON_KEYS;
  scene.load.image(yellow, balloonYellow);
  scene.load.image(red, balloonRed);
  scene.load.image(blue, balloonBlue);
  scene.load.image(PARTY_HAT_KEY, partyCone);
}

/**
 * The party hat frame matching frame `index` of a character's idle or walk sheet (both use the
 * order right, up, left, down), or `undefined` if the hat image did not load.
 */
export function partyHatFrame(
  scene: Phaser.Scene,
  animation: CharacterAnimation,
  index: number,
): { key: string; frame: string } | undefined {
  if (!scene.textures.exists(PARTY_HAT_KEY)) return undefined;
  const texture = scene.textures.get(PARTY_HAT_KEY);
  const column = Math.min(Math.max(0, index), HAT_FRAMES_PER_ROW - 1);
  const frame = `${animation}:${column}`;
  if (!texture.has(frame)) {
    const { width, height } = SHEET_FRAME;
    texture.add(frame, 0, column * width, HAT_ROWS[animation] * height, width, height);
  }
  return { key: PARTY_HAT_KEY, frame };
}
